import BookResults from "./BookResults";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { dispatch } from "../../../../state/configureStore";

interface StudentHomeScreenState {
  studentBooks: Record<string, BookResults>;
  isLoading: boolean;
}

const initialState: StudentHomeScreenState = {
  studentBooks: {},
  isLoading: true,
};

const studentHomeScreenSlice = createSlice({
  name: "studentHomeScreenState",
  initialState,
  reducers: {
    addBook: (state, action: PayloadAction<{ assignmentId: string; book: BookResults }>) => {
      if (action.payload.assignmentId in state.studentBooks) {
        delete state.studentBooks[action.payload.assignmentId];
      }

      if (action.payload.book) {
        // See if we have a book
        if (action.payload.assignmentId in state.studentBooks) {
          // If we have a book, we need to see if this book has changed.
          state.studentBooks[action.payload.assignmentId] = action.payload.book;
        } else {
          state.studentBooks[action.payload.assignmentId] = action.payload.book;
        }
      }
    },
    removeBook: (state, action: PayloadAction<string>) => {
      if (action.payload in state.studentBooks) {
        delete state.studentBooks[action.payload];
      }
    },
    clearBooks: state => {
      state.studentBooks = {};
    },
    startLoading: state => {
      state.isLoading = true;
    },
    finishLoading: state => {
      state.isLoading = false;
    },
  },
});

export type { StudentHomeScreenState };

export const addBook = (assignmentId: string, book: BookResults): void => {
  dispatch(
    studentHomeScreenSlice.actions.addBook({
      assignmentId: assignmentId,
      book: book,
    }),
  );
};

export const removeBook = (assignmentId: string): void => {
  dispatch(studentHomeScreenSlice.actions.removeBook(assignmentId));
};

export const clearBooks = (): void => {
  dispatch(studentHomeScreenSlice.actions.clearBooks());
};

export const startLoading = (): void => {
  dispatch(studentHomeScreenSlice.actions.startLoading());
};

export const finishLoading = (): void => {
  dispatch(studentHomeScreenSlice.actions.finishLoading());
};

export default studentHomeScreenSlice.reducer;
